import { render, staticRenderFns } from "./ordstatisticsdatatime_drying.vue?vue&type=template&id=4bc316ae&"
import script from "./ordstatisticsdatatime_drying.vue?vue&type=script&lang=ts&"
export * from "./ordstatisticsdatatime_drying.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ordstatisticsdatatime_drying.vue"
export default component.exports